import { useMemo } from 'react';
import Fuse from 'fuse.js';
import type { Country } from '@/types';
import countries from '@/data/countries.json';

const allCountries = countries as Country[];

const fuseOptions = {
  keys: ['name', 'officialName', 'altSpellings'],
  threshold: 0.3, // Allow some fuzziness
  includeScore: true,
};

export function useCountrySearch() {
  const fuse = useMemo(() => new Fuse(allCountries, fuseOptions), []);

  const search = (query: string): Country[] => {
    if (!query.trim()) return [];
    const results = fuse.search(query, { limit: 10 });
    return results.map((r) => r.item);
  };

  return { search, countries: allCountries };
}
